import { render, staticRenderFns } from "./AuditTrailFilter.vue?vue&type=template&id=8a5c84a2&"
import script from "./AuditTrailFilter.vue?vue&type=script&lang=js&"
export * from "./AuditTrailFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports